import { useDeleteMarkedQuiz } from '@repo/api/quiz/useDeleteMarkedQuiz';
import { quizErrorMessages } from '@repo/lib/messages/quizErrorMessages';
import { BookIcon } from 'lucide-react';
import { toast } from 'sonner';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogBody,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/dialog';
import { FeaturedIcon } from '@/components/ui/featured-icon';
import { toasterMessageHandler } from '@/lib/toaster-message-handler';

interface DeleteQuizMarkedAttemptDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  quizId: string;
  attemptId?: string;
}
export default function DeleteQuizMarkedAttemptDialog(deleteQuizMarkedAttemptDialogProps: DeleteQuizMarkedAttemptDialogProps) {
  const { open, onOpenChange, quizId, attemptId } = deleteQuizMarkedAttemptDialogProps;
  const { mutateAsync } = useDeleteMarkedQuiz(quizId);

  const onSubmit = async () => {
    if (!attemptId) {
      toast.error('Nie można usunąć podejścia: brak ID podejścia.');
      return;
    }
    await mutateAsync({ quizId, attemptId })
      .then(() => {
        onOpenChange(false);
      })
      .catch((error) => {
        toasterMessageHandler(quizErrorMessages, error);
      });
  };

  return (
    <AlertDialog onOpenChange={onOpenChange} open={open}>
      <AlertDialogContent className={'sm:max-w-96'}>
        <AlertDialogBody>
          <AlertDialogHeader>
            <FeaturedIcon size={'lg'}>
              <BookIcon />
            </FeaturedIcon>
            <div className={'flex min-w-0 grow flex-col gap-0.5'}>
              <AlertDialogTitle>Usuń podejście</AlertDialogTitle>
              <AlertDialogDescription className={'text-muted-foreground text-xs'}>Usuń wybrane podejście użytkownika.</AlertDialogDescription>
            </div>
          </AlertDialogHeader>
        </AlertDialogBody>
        <AlertDialogFooter className={'border-border-primary dark:bg-card bg-accent border-t'}>
          <AlertDialogCancel variant={'tertiary'}>Zamknij</AlertDialogCancel>
          <AlertDialogAction onClick={onSubmit}>Potwierdź</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
